export default __webpack_public_path__ + "static/media/img_3.0f3ccf76.png";